import growthBook from 'services/growthBook';
import isReserhubUnifiedAccountEnabled, {
  isUnifiedAccountEnabledForClient,
  NATIVE_APP_ACCOUNT_FEATURE,
} from 'utils/unifiedAccountEnablement';

/**
 * Reads GrowthBook unified_account for Reserhub; safe when the global store or GrowthBook is unavailable (e.g. tests).
 * @returns {boolean|string|object|undefined}
 */
export function getUnifiedAccountFeatureForReserhub() {
  try {
    return growthBook.getGrowthBookFeature('unified_account');
  } catch {
    return undefined;
  }
}

// Re-exported so existing import sites keep working. The enablement policy itself lives in
// `utils/unifiedAccountEnablement`, which imports no services — import from there instead when the
// Redux store must stay out of the consumer's import graph.
export { isUnifiedAccountEnabledForClient, NATIVE_APP_ACCOUNT_FEATURE };
export default isReserhubUnifiedAccountEnabled;
